import { createSlice } from '@reduxjs/toolkit';
import { fetchUserDetails } from './user.actions';

const initialState = {
  isUserDataSet: false,
  isLoading: false,
  userId: '',
  username: '',
  email: '',
  imageUrl: ''
};

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setIsUserDataSet(state, action) {
      state.isUserDataSet = action.payload;
    },
    setUserId(state, action) {
      state.userId = action.payload;
    },
    setUsername(state, action) {
      state.username = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setImageUrl(state, action) {
      state.imageUrl = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserDetails.fulfilled, (state, action) => {
      state.isLoading = false;

      if (!action.payload) return;

      state.imageUrl = action.payload.avatar;
      state.userId = action.payload.userId;
      state.email = action.payload.email;
      state.isUserDataSet = true;
    });
    builder.addCase(fetchUserDetails.rejected, (state, action) => {
      state.isLoading = false;
    });
  }
});

export const {
  setUserId,
  setUsername,
  setEmail,
  setImageUrl,
  setIsUserDataSet
} = userSlice.actions;

export default userSlice.reducer;
